// This file is auto-generated. Do not edit!

export default [
  {
    symbol: "wstETH",
    token: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xC035a7cf15375cE2706766804551791aD035E0C2",
    variableDebtTokenAddress: "0xE439edd2625772AA635B437C099C607B6eb7d35f",
  },
  {
    symbol: "WETH",
    token: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xfA1fDbBD71B0aA16162D76914d69cD8CB3Ef92da",
    variableDebtTokenAddress: "0x91b7d78BF92db564221f6B5AeE744D1727d1Dd1e",
  },
  {
    symbol: "USDS",
    token: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x09AA30b182488f769a9824F15E6Ce58591Da4781",
    variableDebtTokenAddress: "0x2D9fe18b6c35FE439cC15D932cc5C943bf2d901E",
  },
  {
    symbol: "USDC",
    token: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x2A1FBcb52Ed4d9b23daD17E1E8Aed4BB0E6079b8",
    variableDebtTokenAddress: "0xeD90dE2D824Ee766c6Fd22E90b12e598f681dc9F",
  },
  {
    symbol: "ezETH",
    token: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x74e5664394998f13B07aF42446380ACef637969f",
    variableDebtTokenAddress: "0x08e1bba76D27841dD91FAb4b3a636A0D5CF8c3E9",
  },
  {
    symbol: "sUSDe",
    token: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xc2015641564a5914A17CB9A92eC8d8feCfa8f2D0",
    variableDebtTokenAddress: "0x2ABbAab3EF4e4A899d39e7EC996b5715E76b399a",
  },
  {
    symbol: "GHO",
    token: "0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x18eFE565A5373f430e2F809b97De30335B3ad96A",
    variableDebtTokenAddress: "0x18577F0f4A0B2Ee6F4048dB51c7acd8699F97DB8",
  },
  {
    symbol: "rsETH",
    token: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0x56D919E7B25aA42F3F8a4BC77b8982048F2E84B4",
    variableDebtTokenAddress: "0x2c2163f120cf58631368981BC16e90190Bc6C644",
  },
  {
    symbol: "tETH",
    token: "0xD11c452fc99cF405034ee446803b6F6c1F6d5ED8",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xce8c60fd8390eFCc3Fc66A3f0bd64BEb969e750E",
    variableDebtTokenAddress: "0xe7ea6125490ae4594aD9B44D05dFF9F2A4343134",
  },
] as const
